var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RawWaterfallSlot',_vm._b({ref:"waterfallSlot",style:(_vm.isShow?'':"opacity: 0;"),attrs:{"move-class":"vue-waterfall-slot-ani"}},'RawWaterfallSlot',_vm.realProps,false),[_c('div',{ref:"inner",staticClass:"inner"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }